import { render, staticRenderFns } from "./index.vue?vue&type=template&id=056c850e&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Slides: require('/var/www/ep-web/components/Slides.vue').default,CategoriesGrid: require('/var/www/ep-web/components/CategoriesGrid.vue').default,CategorySlide: require('/var/www/ep-web/components/CategorySlide.vue').default,ContactForm: require('/var/www/ep-web/components/ContactForm.vue').default})
